export default __webpack_public_path__ + "static/media/slide04.446e1bdf.webp";